import AdultSymptomExercisePage from '@/components/AdultSymptomExercisePage';
import { isAdultExerciseGroup } from '@/lib/data/contentCatalog';
import { createFileRoute } from '@tanstack/react-router'
import ExerciseImage from "@/assets/exercise-background-photos/truama.jpg";
import traumaVideo1Mp4 from '@/assets/videos/adults-symptoms/trauma/trauma.mp4';
import traumaVideo1Webm from '@/assets/videos/adults-symptoms/trauma/trauma.webm';
import traumaVideo2Mp4 from '@/assets/videos/adults-symptoms/trauma/trauma-symptoms.mp4';
import traumaVideo2Webm from '@/assets/videos/adults-symptoms/trauma/trauma-symptoms.webm';
import traumaPoster from '@/assets/sarah-truama-vid-thumb-1.png';
import traumaAr from '/subs/trauma.ar.vtt';
import traumaEn from '/subs/trauma.en.vtt';
import traumaSympAr from '/subs/trauma-symptoms.ar.vtt';
import traumaSympEn from '/subs/trauma-symptoms.en.vtt';
import { useLocaleStore } from '@/lib/stores/localeStore';

export const Route = createFileRoute('/(content)/adults/exercises/trauma/')({
   component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    group: isAdultExerciseGroup(search.group) ? search.group : undefined,
    mode: (search.mode === 'videos' || search.mode === 'exercises') ? search.mode as 'videos' | 'exercises' : undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Do you feel stressed? - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "stress.title",
    navbar: {
      transparent: true,
      showTitle: false,
    },
  }),
});

function RouteComponent() {
  const { group, mode } = Route.useSearch();
  const navigate = Route.useNavigate();
  const locale = useLocaleStore((state) => state.locale);
  const captionsDir: 'ltr' | 'rtl' = locale === 'ar' ? 'rtl' : 'ltr';
  const videos = [
    {
      sources: [
        { src: traumaVideo1Webm, type: 'video/webm' },
        { src: traumaVideo1Mp4, type: 'video/mp4' },
      ],
      subtitleTracks: [
        { src: traumaAr, srcLang: 'ar', label: 'Arabic', default: true },
        { src: traumaEn, srcLang: 'en', label: 'English' },
      ],
      activeSubtitleLanguage: locale === 'ar' ? 'ar' : 'en',
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
    {
      sources: [
        { src: traumaVideo2Webm, type: 'video/webm' },
        { src: traumaVideo2Mp4, type: 'video/mp4' },
      ],
      subtitleTracks: [
        { src: traumaSympAr, srcLang: 'ar', label: 'Arabic', default: true },
        { src: traumaSympEn, srcLang: 'en', label: 'English' },
      ],
      activeSubtitleLanguage: locale === 'ar' ? 'ar' : 'en',
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
  ];

  return (
    <AdultSymptomExercisePage
      symptom="trauma"
      titleKey="trauma.title"
      heroImage={ExerciseImage}
      poster={traumaPoster}
      videos={videos}
      videoCards={[
        {
          titleKey: "traumas.video1.title",
          descriptionKey: "traumas.video1.description",
          duration: "4",
          poster: traumaPoster,
        },
        {
          titleKey: "traumas.video2.title",
          descriptionKey: "traumas.video2.description",
          duration: "2",
          poster: traumaPoster,
        },
      ]}
      mode={mode}
      onModeChange={(nextMode) =>
        navigate({
          to: Route.to,
          search: {
            mode: nextMode ?? undefined,
            group: nextMode === 'exercises' ? group : undefined,
          },
        })
      }
      selectedGroup={group}
      onSelectGroup={(nextGroup) =>
        navigate({
          to: Route.to,
          search: { mode: 'exercises', group: nextGroup },
        })
      }
    />
  );
}
